<template>
	<div class="tabulation" v-loading="loading" element-loading-text="加载中"
		element-loading-background="rgb(255, 255, 255, 0.5)">
		<el-card class="chart-card">
			<div style="margin-top: 20px;">
				<el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize"
					status-icon>
					<!-- 标题 -->
					<el-form-item label="标题名称" prop="name">
						<div class="aaaa">
							<el-input v-model="form.name" placeholder="请填写标题" size="large"></el-input>
						</div>
					</el-form-item>
					<!-- 标题图片 -->
					<el-form-item label="主题图片" prop="breviary">
						<el-upload action="/admin/previous/saveImage" list-type="picture-card" limit="1" ref="uploadRef"
							v-model="form.breviary" :auto-upload="true" :on-change="change" :on-remove="Remove"
							:class="styA==0&&styD==0?'styB':'styC'" :before-upload="beforeImageUpload"
							:before-remove="beforeremove" :on-preview="onpreview" :headers="header" :file-list="approve"
							accept=".jpeg,.png,.jpg,.bmp,.gif" :data='{
              imageFile: file
              }' name="imageFile" :on-success="succ" :on-error="uploadError">
							<el-icon>
								<Plus />
							</el-icon>
						</el-upload>

						<el-dialog v-model="dialogVisible">
							<img w-full :src="dialogImageUrl" alt="Preview Image" style="width:100%" />
						</el-dialog>
						<div class="referrals">
							( 推荐：图片尺寸 宽700px、高280px。 )
						</div>
					</el-form-item>
					<!-- 活动分类 -->
					<el-form-item label="活动类型" prop="classify">
						<el-select v-model="form.classify" placeholder="请选择类型" size="medium">
							<el-option label="直属机关工会" value="1"
								style="width:100%; text-align-last: center;"></el-option>
							<el-option label="基层工会" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 是否发布 -->
					<el-form-item label="是否发布" prop="are">
						<el-select v-model="form.are" placeholder="请选择是否发布" size="medium">
							<el-option label="是" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="否" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 可见范围 -->
					<el-form-item label="可见范围" prop="visibleType">
						<el-select v-model="form.visibleType" placeholder="请选择可见范围" size="medium" @change="visibleTypeChange">
							<el-option label="全部可见" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="指定工会可见" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					</el-form-item>
					<!-- 请选择可见工会 -->
					<el-form-item v-if="form.visibleType == '2'" label="可见工会" prop="visibleUnionName">
						<el-select @focus="closeIt" v-model="visibleUnionSelectValue" placeholder="请选择可见工会" size="medium"
							@click="multiple" clearable @clear="clearVisibleUnion" ref="selectIt" />
					</el-form-item>
					<el-form-item v-if="form.visibleType == '2' && visibleUnionTags.length" label=" ">
						<div class="visible-union-tags">
							<el-tag v-for="tag in visibleUnionTags" :key="tag.name" closable :type="tag.type"
								@close="removeVisibleUnionTag(tag)">
								{{ tag.name }}
							</el-tag>
						</div>
					</el-form-item>
					<!-- 编辑器 -->
					<el-form-item prop="copyreader">
						<div class="subject">
							<span class="xingxing">*</span>
							主体内容
							<span class="referrals">( 推荐：视频体积小于100M，图片体积小于1M。 )</span>
						</div>
						<div style="border: 1px solid #ccc; width:100%">
							<Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef"
								:defaultConfig="toolbarConfig" :mode="mode" />

							<Editor style="height: 500px; overflow-y: hidden" v-model="valueHtml"
								:defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" />
						</div>
					</el-form-item>
				</el-form>
			</div>
			<el-button type="primary" size="large" style="margin-top: 20px;" :loading="ConfirmLoading"
				@click="onSubmit">提交</el-button>
		</el-card>
		<!-- 可见工会弹窗 -->
		<div>
			<s3-layer v-model="visible" title="可见工会" :shadeClose="true" :area="['500px', '80vh']">
				<el-tree ref="visibleUnionTreeRef" :data="texture" :props="defaultProps" node-key="unionId"
					show-checkbox accordion @check="handleVisibleUnionCheck" />
			</s3-layer>
		</div>
	</div>
</template>
<script>
	import '@wangeditor/editor/dist/css/style.css' // 引入 css
	import {
		onBeforeUnmount,
		ref,
		shallowRef,
		onMounted,
		reactive,
		onActivated,
		nextTick
	} from 'vue'
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	import {
		Plus,
	} from '@element-plus/icons-vue'
	import * as imageConversion from 'image-conversion'
	import {
		ElMessage
	} from "element-plus";
	import {
		FCsubmit,
		FCredact,
		ZClist
	} from "../../utils/api"
	import {
		useRouter,
		useRoute
	} from "vue-router";
	import {
		useStore
	} from "vuex";
	// import { Pictures } from '../../utils/api'
	import qs from 'qs'
	export default {
		name: "FCdit",
		components: {
			Editor,
			Toolbar,
			Plus,
		},
		setup() {
			const route = useRoute();
			// 加载框
			let loading = ref(true)
			// 默认显示已上传文件
			let approve = ref([])
			// 可见工会选择
			let visibleUnionKeys = ref([])
			let visibleUnionIds = ref([])
			let visibleUnionTags = ref([])
			let visibleUnionSelectValue = ref('')
			let selectIt = ref()
			let visibleUnionTreeRef = ref()
			let visible = ref(false)
			let texture = ref([])
			const defaultProps = {
				children: 'unionDtoList',
				label: 'unionName',
			}
			const closeIt = () => {
				selectIt.value && selectIt.value.blur()
			}
			const multiple = () => {
				visible.value = true
				nextTick(() => {
					if (visibleUnionTreeRef.value) {
						visibleUnionTreeRef.value.setCheckedKeys(visibleUnionKeys.value)
					}
				})
			}
			const findVisibleUnionNodes = (list, ids, result = []) => {
				list.forEach((item) => {
					if (ids.includes(String(item.unionId))) {
						result.push(item)
					}
					if (item.unionDtoList && item.unionDtoList.length) {
						findVisibleUnionNodes(item.unionDtoList, ids, result)
					}
				})
				return result
			}
			const syncVisibleUnionTags = () => {
				const idStrings = visibleUnionIds.value.map((item) => String(item))
				const checkedNodes = findVisibleUnionNodes(texture.value, idStrings)
				if (checkedNodes.length) {
					visibleUnionKeys.value = checkedNodes.map((item) => item.unionId)
					visibleUnionTags.value = checkedNodes.map((item) => ({
						id: item.unionId,
						name: item.unionName,
						type: ''
					}))
				} else {
					visibleUnionKeys.value = [...visibleUnionIds.value]
					visibleUnionTags.value = visibleUnionIds.value.map((item) => ({
						id: item,
						name: String(item),
						type: ''
					}))
				}
				form.visibleUnionName = visibleUnionTags.value.map((item) => item.name).join('、')
			}
			const handleVisibleUnionCheck = (node, checkedInfo) => {
				const checkedNodes = checkedInfo.checkedNodes || []
				visibleUnionKeys.value = checkedNodes
					.map((item) => item.unionId)
					.filter((item) => item !== undefined && item !== null)
				visibleUnionIds.value = visibleUnionKeys.value.map((item) => String(item))
				visibleUnionTags.value = checkedNodes.map((item) => ({
					id: item.unionId,
					name: item.unionName,
					type: ''
				}))
				form.visibleUnionName = visibleUnionTags.value.map((item) => item.name).join('、')
				visibleUnionSelectValue.value = ''
			}
			const removeVisibleUnionTag = (tag) => {
				visibleUnionTags.value = visibleUnionTags.value.filter((item) => String(item.id) !== String(tag.id))
				visibleUnionKeys.value = visibleUnionTags.value.map((item) => item.id)
				visibleUnionIds.value = visibleUnionTags.value.map((item) => String(item.id))
				form.visibleUnionName = visibleUnionTags.value.map((item) => item.name).join('、')
				if (visibleUnionTreeRef.value) {
					visibleUnionTreeRef.value.setCheckedKeys(visibleUnionKeys.value)
				}
			}
			const clearVisibleUnion = () => {
				form.visibleUnionName = ''
				visibleUnionSelectValue.value = ''
				visibleUnionTags.value = []
				visibleUnionKeys.value = []
				visibleUnionIds.value = []
				if (visibleUnionTreeRef.value) {
					visibleUnionTreeRef.value.setCheckedKeys([])
				}
			}
			const visibleTypeChange = (value) => {
				if (value == '1') {
					clearVisibleUnion()
					visible.value = false
				}
			}
			const own = () => {
				ZClist().then((res) => {
					if (res.data.code == 0) {
						texture.value = res.data.data.manageUnionList || res.data.data.wholeUnionList || []
						if (visibleUnionIds.value.length) {
							syncVisibleUnionTags()
						}
					}
				})
			}
			// 子女托管编辑获取信息
			let dact = () => {
				let data = {
					id: sessionStorage.getItem('demeanour')
				}
				FCredact(qs.stringify(data)).then((res) => {
					console.log(res)
					if (res.data.code == 0) {
						const previousDataInfo = res.data.data.previousDataInfo
						loading.value = false
						valueHtml.value = previousDataInfo.content
						form.name = previousDataInfo.title
						// 类型
						if (previousDataInfo.type == 1) {
							form.classify = '直属机关工会'
						} else if (previousDataInfo.type == 2) {
							form.classify = '基层工会'
						}
						// 是否发布
						if (previousDataInfo.isEnable == 2) {
							form.are = '否'
						} else if (previousDataInfo.isEnable == 1) {
							form.are = '是'
						}
						form.visibleType = previousDataInfo.visibleType ? String(previousDataInfo.visibleType) : '1'
						visibleUnionIds.value = (previousDataInfo.visibleUnionIds || []).map((item) => String(item))
						if (form.visibleType == '2' && visibleUnionIds.value.length) {
							syncVisibleUnionTags()
						} else {
							clearVisibleUnion()
						}
						if (previousDataInfo.imageInfo == null || previousDataInfo.imageInfo == '') {
							styD.value = 0
						} else {
							styD.value = 1
							let data = {
								url: previousDataInfo.imageInfo
							}
							approve.value.push(data)
						}
					}
				})
			}
			let data = ref(null);
			// 按钮加载
			const ConfirmLoading = ref(false)

			// 上传图片
			const header = ref({
				timeout: 10000,
				'accessToken': sessionStorage.getItem('token')
			})
			// 获取上传图片成功地址
			let location = ref('')
			let uploadRef = ref()
			const resetUploadFile = (file, message = '图片上传失败，请重新上传') => {
				location.value = ''
				form.breviary = []
				styA.value = 0
				styD.value = 0
				const clearUploadFiles = () => {
					if (uploadRef.value && uploadRef.value.clearFiles) {
						uploadRef.value.clearFiles()
					}
				}
				clearUploadFiles()
				nextTick(clearUploadFiles)
				ElMessage({
					message,
					type: "error",
					center: true,
				});
			}
			const succ = (res, file) => {
				if (!res || (res.code !== undefined && res.code != 0) || !res.data) {
					resetUploadFile(file, res && res.msg ? res.msg : '图片上传失败，请重新上传')
					return
				}
				location.value = res.data
			}
			const uploadError = (err, file) => {
				console.log(err)
				resetUploadFile(file)
			}
			// 自定义上传
			const httpreqst = (param) => {
				console.log(param)
				console.log(param.file.name)
				data.value = {
					imageFile: param.file.namefileList
				}
				// Pictures(data).then((res)=>{
				//   console.log(res)
				// })
			}
			const styA = ref(0)
			const styD = ref(1)

			const change = (res, fileList) => {
				// console.log(res)
				styA.value = fileList.length
				form.breviary = fileList
				// console.log(fileList)
			}
			const beforeImageUpload = (File) => {
				let isLt2M = File.size / 1024 / 1024 < 1
				return new Promise((resolve) => {
					if (isLt2M) {
						resolve(File)
					}
					imageConversion.compressAccurately(File, 930).then((res) => {
						resolve(res);
						// data.value = File.name
					});
				})
			}
			// 图片放大
			const dialogVisible = ref(false)
			let dialogImageUrl = ref('')
			const onpreview = (File) => {
				dialogVisible.value = true
				dialogImageUrl.value = File.url
				console.log(File)
			}
			// 删除图片
			const beforeremove = (File, fileList) => {
				console.log(File)
				console.log(fileList)
				styD.value = 0
				styA.value = 0
			}
			const Remove = (file) => {
				console.log(file)
			}
			// 类型
			let typological = ref(null)
			// 是否发布
			let fabu = ref(null)

			// 提交 按钮
			// 关闭当前页
			const store = useStore();
			const current = ref('')
			const expression = ref([])
			const Indexs = ref(null)


			const router = useRouter();
			const onSubmit = () => {
				if (valueHtml.value == '<p><br></p>') {
					form.copyreader = ''
				} else {
					form.copyreader = valueHtml.value
				}
				// console.log('标题',form.name)
				console.log('缩略图地址', location.value)
				// console.log('是否发布',form.are)
				// console.log('编辑器内容',form.copyreader)
				// 类型
				if (form.classify == '直属机关工会') {
					typological.value = 1
				} else if (form.classify == '基层工会') {
					typological.value = 2
				} else if (form.classify == 1) {
					typological.value = 1
				} else if (form.classify == 2) {
					typological.value = 2
				}
				// 是否发布
				if (form.are == '否') {
					fabu.value = 2
				} else if (form.are == '是') {
					fabu.value = 1
				} else if (form.are == 1) {
					fabu.value = 1
				} else if (form.are == 2) {
					fabu.value = 2
				}
				ruleFormRef.value.validate((valid) => {
					console.log(valid)
					let data = {
						id: sessionStorage.getItem('demeanour'),
						// 标题
						title: form.name,
						// 图片
						imageInfo: location.value,
						// 是否公开
						isEnable: fabu.value,
						// 编辑器内容
						content: form.copyreader,
						// 类型
						type: typological.value,
						// 可见范围
						visibleType: form.visibleType,
						// 可见工会
						visibleUnionIds: form.visibleType == '2' ? visibleUnionIds.value : []
					}
					if (valid == true) {
						ConfirmLoading.value = true
						FCsubmit(qs.parse(data)).then((res) => {
							console.log(res)
							if (res.data.code == 0) {
								ElMessage({
									message: '提交成功',
									type: "success",
									center: true,
								});
								setTimeout(() => {
									current.value = route.path
									expression.value = store.state.tagsList

									expression.value.forEach((item, index) => {
										if (current.value == item.path) {
											Indexs.value = index
										}
									})
									store.state.tagsList.splice(Indexs.value, 1)
									router.push({
										name: 'elegant',
										params: {
											userId: 1
										}
									});
									ConfirmLoading.value = false
								}, 500)
							} else {
								ElMessage({
									message: res.data.msg,
									type: "error",
									center: true,
								});
								ConfirmLoading.value = false
							}
						})
					} else {
						ElMessage({
							message: "提交失败",
							type: "error",
							center: true,
						});
						ConfirmLoading.value = false
					}
				})
			}
			// 编辑器实例，必须用 shallowRef
			const editorRef = shallowRef()

			// 内容 HTML
			const valueHtml = ref('')

			// 模拟 ajax 异步获取内容
			let translate = ref(2)
			onActivated(() => {
				translate.value = route.params.UserId
				if (translate.value == 1) {
					approve.value = []
					own()
					dact()
				}
				// loading.value=true

			})
			// onMounted(() => {
			//   approve.value=[]
			//   // dact()
			// })

			const toolbarConfig = {
				toolbarKeys: [
					'bold', // 加粗
					'italic', // 斜体
					'through', // 删除线
					'underline', // 下划线
					'bulletedList', // 无序列表
					'numberedList', // 有序列表
					'color', // 文字颜色
					'fontSize', // 字体大小
					'lineHeight', // 行高
					'uploadImage', // 上传图片
					'delIndent', // 缩进
					'indent', // 增进
					'deleteImage', //删除图片
					'justifyCenter', // 居中对齐
					'justifyJustify', // 两端对齐
					'justifyLeft', // 左对齐
					'justifyRight', // 右对齐
					'undo', // 撤销
					'redo', // 重做
					'clearStyle', // 清除格式
					'uploadVideo', //上传视频
				],
				excludeKeys: [
					'insertImage', // 网络图片
					'bgColor', // 背景色
					'blockquote', // 引用
					'codeBlock', // 代码段
					'emotion', // 表情
					'fontFamily', // 字体
					'headerSelect', // 标题 
					'fullScreen', // 全屏
				],
			}
			// 富文本上传图片地址
			// let fils=ref('')
			// placeholder: '请输入内容...',
			const editorConfig = {
				MENU_CONF: {}
			}
			// 视频上传
			editorConfig.MENU_CONF['uploadVideo'] = {
				// 上传视频的配置
				// 接口
				server: '/admin/previous/saveEditorImage',
				// 请求头
				headers: {
					timeout: 10000,
					'accessToken': sessionStorage.getItem('token')
				},
				maxFileSize: 104857600, // 100M
				//上传字段 
				fieldName: 'imageFile',
				maxNumberOfFiles: 1,
				// 上传前回调
				onBeforeUpload(file) {
					console.log(file)
					let fileObj = Object.values(file)[0].data
					console.log(fileObj)
					// 压缩图片
					let isLt2M = Object.values(file)[0].data.size
					if (isLt2M < 104857600) {
						return true
					} else if (isLt2M > 104857600) {
						ElMessage({
							message: '视频大小不能超过100MB,请重新上传',
							type: "warning",
							center: true,
						});
						return false
					}
				},
				// 上传成功后回调
				onSuccess(file, res) {
					console.log(file)
					console.log(res)
				},
				// 上传失败回调
				onError(file, err, res) {
					console.log(file)
					console.log(err)
					console.log(res)
					if (file.size > 104857600) {
						ElMessage({
							message: '视频大小不能超过100MB,请重新上传',
							type: "warning",
							center: true,
						});
					} else {
						ElMessage({
							message: '上传失败，请稍后再试',
							type: "warning",
							center: true,
						});
					}
				},
			}


			// 图片上传
			editorConfig.MENU_CONF['uploadImage'] = {
				// 上传图片的配置 
				// 接口
				server: '/admin/child/saveEditorImage',
				// 请求头
				headers: {
					timeout: 10000,
					'accessToken': sessionStorage.getItem('token')
				},
				maxFileSize: 1 * 1024 * 1024, // 1M
				//上传字段 
				fieldName: 'imageFile',
				// meta: {
				//   imageFile:fils
				// },
				// 最多可上传几个文件，默认为 100
				maxNumberOfFiles: 1,
				// 上传前回调
				onBeforeUpload(file) {
					console.log(file)
					let fileObj = Object.values(file)[0].data
					console.log(fileObj)
					// 压缩图片
					let isLt2M = Object.values(file)[0].data.size
					if (isLt2M < 1048576) {
						return true
					} else if (isLt2M > 1048576) {
						ElMessage({
							message: '图片大小不能超过1MB,请重新上传',
							type: "warning",
							center: true,
						});
						return false
					}
				},
				// 上传成功后回调
				onSuccess(file, res) {
					console.log(file)
					console.log(res)
				},
				// 上传失败回调
				onError() {
					ElMessage({
						message: '图片大小不能超过1MB,请重新上传',
						type: "warning",
						center: true,
					});
				},
			}

			// 组件销毁时，也及时销毁编辑器
			onBeforeUnmount(() => {
				const editor = editorRef.value
				if (editor == null) return
				editor.destroy()
			})

			const handleCreated = (editor) => {
				editorRef.value = editor // 记录 editor 实例，重要！
				// console.log(editor)
			}
			// 标题验证
			const ruleFormRef = ref(null)
			const form = reactive({
				name: "",
				sex: "",
				breviary: "",
				copyreader: "",
				are: '',
				bywork: '',
				classify: '',
				visibleType: '',
				visibleUnionName: ''
			})
			// 验证表单提示
			const rules = {
				are: [{
					required: true,
					message: "请选择是否发布",
					trigger: "change"
				}, ],
				visibleType: [{
					required: true,
					message: "请选择可见范围",
					trigger: "change"
				}, ],
				visibleUnionName: [{
					required: true,
					message: "请选择可见工会",
					trigger: "change"
				}, ],
				copyreader: [{
					required: true,
					message: "请填写内容",
					trigger: "change"
				}, ],
				name: [{
					required: true,
					message: "请填写标题",
					trigger: "blur"
				}, ],
				sex: [{
					required: true,
					message: "请选择分类",
					trigger: "change"
				}, ],
				classify: [{
					required: true,
					message: "请选择类型",
					trigger: "change"
				}, ],
			}
			return {
				loading,
				approve,
				uploadRef,
				header,
				succ,
				uploadError,
				data,
				// 按钮加载
				ConfirmLoading,
				// 上传图片
				httpreqst,
				dialogVisible,
				dialogImageUrl,
				onpreview,
				beforeremove,
				Remove,
				styA,
				styD,
				change,
				beforeImageUpload,
				// handlePictureCardPreview,
				// 编辑器
				onSubmit,
				editorRef,
				valueHtml,
				mode: 'default',
				toolbarConfig,
				editorConfig,
				handleCreated,
				selectIt,
				visibleUnionTreeRef,
				visibleUnionSelectValue,
				visibleUnionTags,
				closeIt,
				visible,
				multiple,
				defaultProps,
				texture,
				handleVisibleUnionCheck,
				removeVisibleUnionTag,
				clearVisibleUnion,
				visibleTypeChange,
				// 标题验证
				ruleFormRef,
				form,
				rules
			}
		}
	}
</script>
<style lang='scss' scoped>
	::v-deep .chart-card::-webkit-scrollbar {
		display: none
	}

	::v-deep .chart-card {
		height: calc(100vh - 145px);
		overflow: auto;
	}

	::v-deep .subject {
		margin-left: 3px;
		font-size: var(--el-form-label-font-size);
		font-weight: bold;
		margin-bottom: 5px;
		color: var(--el-text-color-regular);

		.xingxing {
			color: var(--el-color-danger);
		}
	}

	// .w-e-text-container [data-slate-editor] p{
	//   margin-top: 22px;
	//   margin-bottom: 22px;
	// }
	::v-deep .el-button {
		width: 100px;
		height: 40px;
		font-size: 16px;
	}

	::v-deep .el-form-item__content {
		align-items: flex-end;
	}

	::v-deep .referrals {
		color: #cccccc;
		margin-left: 5px;
		font-weight: 500;
	}

	::v-deep .visible-union-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	::v-deep .styB .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	::v-deep .styC .el-upload--picture-card {
		display: none;
	}

	::v-deep .el-form-item {
		align-items: center;
	}

	::v-deep .aaaa {
		width: 50%;
	}

	::v-deep .el-card__body {
		padding: 0;
	}

	::v-deep .el-main {
		overflow: auto !important;
	}

	::v-deep .el-card.is-always-shadow {
		width: 95%;
		margin: auto;
		margin-top: 10px;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
	}

	::v-deep .tabulation {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		overflow: auto !important;
	}
</style>
<style scoped>
	::v-deep .upload-demo {
		display: flex;
		width: 100%;
	}

	::v-deep .upload-demo .el-upload-list {
		display: flex;
		width: 50%;
	}

	::v-deep .el-input {
		height: 44px !important;
	}

	::v-deep .el-form-item__label {
		width: 80px !important;
		font-weight: bold;
	}
</style>
